<template>
    <div>
        <div class="form-group">
            <label>Numero massimo QR</label>
            <input class="form-control" type="number" v-model="localValue.generatedQrLimit" />
            <div class="small text-danger" v-if="!qrLimitsOk">I QR attivi superano il numero massimo</div>
        </div>
        <div class="form-group">
            <label>Numero massimo QR attivi</label>
            <input class="form-control" type="number" v-model="localValue.activeQrLimit" />
            <div class="small text-danger" v-if="!qrLimitsOk">I QR attivi superano il numero massimo</div>
        </div>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import * as OM from '@/model';
import { ModalServices } from '@/services/ModalServices';
import * as VM from '@/viewmodel';
import { mixins, Options, Vue } from 'vue-class-component';

@Options({})
export default class tenantAllowances extends mixins(WithModel) {

    declare localValue: OM.Allowances;

    get qrLimitsOk(){
        return this.localValue.activeQrLimit <= this.localValue.generatedQrLimit;
    }

}

</script>
